export default __webpack_public_path__ + "static/media/menu-dealer.b14d8c3d.svg";